module.exports = __webpack_public_path__ + "static/media/03_Interview_Florian_Hauser.39435abe.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle03/03_Interview_Florian_Hauser.mp4
 ** module id = 381
 ** module chunks = 0
 **/